import { DatePipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { MatIconButton } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog'
import { MatIcon } from '@angular/material/icon'
import { MatToolbar } from '@angular/material/toolbar'
import { ElderThemeDirective, Interval, IsoIntervalPipe } from '@elderbyte/ngx-starter'
import { Instant } from '@js-joda/core'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { MexusContext } from '../../../../context/mexus-context.service'
import { MexusViewMode } from '../../../../context/view-mode-context/mexus-view-mode'
import { Facility } from '../../../../facilities/facility'
import { FacilityUtilisationDetailComponent } from '../facility-utilisation-detail/facility-utilisation-detail.component'

export interface IFacilityUtilisationDialogOptions {
  readonly facility: Facility
  readonly scheduledInterval: Interval
  readonly timestamp: Instant
  readonly viewMode: MexusViewMode
}

@Component({
  selector: 'app-facility-utilisation-detail-dialog',
  templateUrl: './facility-utilisation-detail-dialog.component.html',
  styleUrls: ['./facility-utilisation-detail-dialog.component.scss'],
  imports: [
    MatToolbar,
    ElderThemeDirective,
    MatIconButton,
    MatDialogClose,
    MatIcon,
    FacilityUtilisationDetailComponent,
    DatePipe,
    ElderTranslatePipe,
    IsoIntervalPipe,
  ],
})
export class FacilityUtilisationDetailDialogComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly ctx
  public readonly ViewMode = MexusViewMode
  readonly data = inject<IFacilityUtilisationDialogOptions>(MAT_DIALOG_DATA)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.ctx = new MexusContext(
      this.data.facility,
      this.data.scheduledInterval,
      this.data.viewMode,
      this.data.timestamp
    )
  }
}
